import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetAccountInfo, useGetIsLoggedIn } from '@multiversx/sdk-dapp/hooks';
import { logout } from '@multiversx/sdk-dapp/utils';

import clsx from 'clsx';

import Button from 'react-bootstrap/Button';

import LogoWithText from 'assets/img/logo.png';
import { shortenAddress } from 'helpers/utils';
import styles from './styles.module.scss';

export const Header = () => {
  const isLoggedIn = useGetIsLoggedIn();
  const { address: userAddress } = useGetAccountInfo();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout(`${window.location.origin}/unlock`);
  };

  return (
    <div className={clsx(styles.header, 'd-flex')}>
      <div className={styles.logoContainer}>
        <img className={styles.logo} src={LogoWithText} alt='onedex logo' />
      </div>
      <Button
        className={styles.connect}
        onClick={() => {
          isLoggedIn ? handleLogout() : navigate('/unlock');
        }}
      >
        {isLoggedIn ? shortenAddress(userAddress) : 'Connect Wallet'}
      </Button>
    </div>
  );
};
